import './confirmationCodeForm.css'

class ConfirmationCodeFormController {
  /* @ngInject */

  /**
   * @param {*} $mdDialog 
   * @param {*} $mdToast 
   * @param {(confirmationCode: string) => Promise<any>} handleSubmitCode
   */
  constructor ($scope ,$mdDialog, $mdToast, handleSubmitCode) {
    this.$scope = $scope
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.confirmationCode = ""
    this.handleSubmitCode = handleSubmitCode
    this.submitError = null
  }

  // Clear errors when a user types in the field again
  onChange () {
    this.submitError = null
  }

  async submitCode() {
    try {
      const result = await this.handleSubmitCode(this.confirmationCode.toString())
      return result;
    } catch (e) {
      let message = e?.data?.reason
      message = message ?? e.message
      message = message ?? "An Unknown error occured"

      this.submitError = message
    }
  }

  closeDialog () {
    this.$mdDialog.cancel()
  }
}

export default ConfirmationCodeFormController
